<template>
  <el-dialog :id="$options.name"
             :before-close="noDialog" :fullscreen="dialogFullscreen"
             :visible.sync="dialog" title="批量设置电卡">
    <el-form label-width="auto">
      <el-form-item label="门禁卡设备类型">
        <el-select v-model="type" placeholder="选择门禁卡设备类型:">
          <el-option
              v-for="card in status"
              :key="card.label"
              :label="card.label"
              :value="card.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取消</el-button>
      <el-button type="primary" @click="setCardList">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import maintainBatchSetCardDeviceType from "@/maintain/api/user/card-manage/maintainBatchSetCardDeviceType";

import dialogMixin from "@/mixin/dialogMixin";
import dividendMixin from "@/mixin/dividendMixin";
import listMixin from "@/mixin/listMixin";
import resDispose from "@/mixin/resDisposeMixin";

export default {
  name: "BatchSetCardDialog",
  mixins: [dialogMixin, resDispose, listMixin, dividendMixin],
  props: {
    dialog: Boolean,
    list: Array,
  },
  data: () => {
    return {
      type: 0,
      status: [{value: 0, label: '不可用门禁'},
        {value: 1, label: '电瓶车'},
        {value: 2, label: '三轮车'}
      ],
    }
  },
  methods: {
    setCardList() {
      maintainBatchSetCardDeviceType({
        idList: this.list,
        type: this.type
      }).then(res => {
        this.resNoDialog({res})
      })
    },
  }

}
</script>
